import { HTML, PDF } from '../constants'

const isMenuScrapeable = menuFormat => menuFormat === HTML || menuFormat === PDF

export default isMenuScrapeable
